/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentResumeeEnrollmentViewModel } from "../types/StudentResumeeEnrollmentViewModel.ts";
import { studentResumeeFinancialPersonSchema } from "./studentResumeeFinancialPersonSchema.ts";

export const studentResumeeEnrollmentViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula no curso."),
  ),
  courseName: z.string().describe("Nome do curso.").nullish(),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  classStudentName: z.string().describe("Nome da turma do aluno.").nullish(),
  statusRegistration: z.optional(
    z.number().int().describe("Código do status da matrícula."),
  ),
  dateApprovation: z
    .string()
    .datetime()
    .describe("Data de aprovação da matrícula. Opcional.")
    .nullish(),
  dateRejection: z
    .string()
    .datetime()
    .describe("Data de rejeição da matrícula. Opcional.")
    .nullish(),
  origionTransferCourseRegistration: z
    .number()
    .int()
    .describe("ID da matrícula de origem em caso de transferência. Opcional.")
    .nullish(),
  targetTransferCourseRegistration: z
    .number()
    .int()
    .describe("ID da matrícula de destino em caso de transferência. Opcional.")
    .nullish(),
  originTransferCourseName: z
    .string()
    .describe("Nome do curso de origem da transferência.")
    .nullish(),
  targetTransferCourseName: z
    .string()
    .describe("Nome do curso de destino da transferência.")
    .nullish(),
  financialPersons: z
    .array(z.lazy(() => studentResumeeFinancialPersonSchema))
    .describe("Lista de responsáveis financeiros associados à matrícula.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação da matrícula. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração da matrícula. Opcional.")
    .nullish(),
  userCreation: z
    .string()
    .describe("Usuário responsável pela criação da matrícula.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração da matrícula.")
    .nullish(),
}) as unknown as ToZod<StudentResumeeEnrollmentViewModel>;
